import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { RelocationModel } from '../../models/Relocation';
import { Card } from './Card';

interface CardListProps {
  relocations: RelocationModel[];
  isLoading?: boolean;
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: unknown;
  onSortingChange?: (sorting: unknown) => void;
  total?: number;
  estimateItemHeight?: number;
  selectedColumns?: string[];
  cartLabelsById?: Record<number, string>;
}

export const CardList = ({
  relocations,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
  total,
  className = '',
  estimateItemHeight = 120,
  selectedColumns,
  cartLabelsById,
}: CardListProps) => {
  const { t } = useTranslation('relocationsModule');

  const renderCard = (props: RenderItemProps<RelocationModel>) => (
    <Card {...props} selectedColumns={selectedColumns} cartLabelsById={cartLabelsById} />
  );

  const itemKey = (row: RelocationModel) => row.id;

  return (
    <VirtualList
      data={relocations}
      renderItem={renderCard}
      itemKey={itemKey}
      estimateItemHeight={estimateItemHeight}
      height="calc(100vh - 150px)"
      gap={0}
      emptyMessage={t('empty.message')}
      className={`rounded-lg shadow-sm ${className}`}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      sorting={sorting}
      onSortingChange={onSortingChange}
      total={total}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
